import QuestionCard from '../components/QuestionCard';
import TopicSEO from '../components/seo/TopicSEO';
import backgroundImage from '../static/background.png';

const Topic = ({ title, description, questions, icon, topicPath }) => {
  return (
    <main className="min-h-screen">
      <TopicSEO title={title} description={description} questions={questions} topicPath={topicPath} />

      {/* Hero Section with Background Image */}
      <div
        className="relative overflow-hidden"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>

        <div className="container mx-auto px-4 py-16 relative z-10">
          <div className="max-w-4xl mx-auto">
            <header className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl mb-4 shadow-lg bg-white">
                <span className="text-4xl">{icon}</span>
              </div>
              <h1 className="text-5xl font-bold text-white pb-4 drop-shadow-lg">
                {title}
              </h1>
              <p className="text-xl text-white max-w-2xl mx-auto drop-shadow-lg">
                {description}
              </p>
            </header>
          </div>
        </div>
      </div>

      {/* Content Section with Default Background */}
      <div className="container mx-auto px-4 py-12 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <section className="space-y-4">
            {questions.map((q, index) => (
              <QuestionCard key={q.id} number={index + 1} question={q.question} parts={q.parts}/>
            ))}
          </section>
        </div>
      </div>
    </main>
  );
};

export default Topic;
